
import { Skeleton } from '@mui/material'
import './styles.css'


export default function ConfigLoader() {
    return (
        <div className="config-loader mt-3">
            <div className='cl-row'>
                <Skeleton variant="rounded" width='62%' height={30} className='mt-1' />
                <div className='cl-row'>
                    <Skeleton variant="circular" width={40} height={40} className='mt-1 mr-1' />
                    <Skeleton variant="circular" width={40} height={40} className='mt-1' />
                </div>
            </div>
            <Skeleton variant="rounded" width='40%' height={30} className='mt-2' />
            <Skeleton variant="rounded" width='100%' height={40} className='mt-1' />
        </div>
    )
}